import _isNil from "lodash/isNil";
import { convertCssTimeToNumber } from './convertCssTimeToNumber';
export var calculateAnimationTimeout = function calculateAnimationTimeout(duration, delay) {
  if (_isNil(duration) || duration === 'inherit' || duration === 'initial') return 0;
  if (delay === 'inherit' || delay === 'initial') return 0;
  return convertCssTimeToNumber(duration) + convertCssTimeToNumber(delay);
};
//# sourceMappingURL=calculateAnimationTimeout.js.map
